import { ModeCard } from './SeriesModeToggle';
import { STRINGS } from '@/strings/strings';

export type EpisodeCount = 5 | 10;

interface EpisodeCountSelectorProps {
  value: EpisodeCount;
  onChange: (value: EpisodeCount) => void;
  /** KP dark bg — high-contrast card treatment (mirrors SeriesModeToggle). */
  dark?: boolean;
}

/** Discrete 5 / 10 episode-count cards (reuses the ModeCard visual). */
export function EpisodeCountSelector({ value, onChange, dark = false }: EpisodeCountSelectorProps) {
  const S = STRINGS.series.builder;
  return (
    <div className="grid grid-cols-2 gap-3">
      <ModeCard
        active={value === 5}
        onClick={() => onChange(5)}
        label={S.episodeCount5}
        description=""
        dark={dark}
      />
      <ModeCard
        active={value === 10}
        onClick={() => onChange(10)}
        label={S.episodeCount10}
        description=""
        dark={dark}
      />
    </div>
  );
}
